<form class="row no-gutters" [formGroup]="autocompleteFilterForm">
  <mat-form-field class="col">
    <mat-chip-list #chipList>
      <mat-chip color="primary" *ngFor="let filter of selectedFilters" [selectable]="false" [removable]="true" (removed)="remove(filter)">
        {{ filter.name }} : {{ filter.viewValue }}
        <mat-icon matChipRemove class="fa-close"></mat-icon>
      </mat-chip>
      <input placeholder="{{this.filterPlaceHolder}}"
             #filterInput
             formControlName="filter"
             [matChipInputFor]="chipList"
             [matAutocomplete]="autocomplete"
             [matChipInputAddOnBlur]="false">
      <mat-autocomplete #autocomplete="matAutocomplete" autoActiveFirstOption (optionSelected)="selected($event)">
        <mat-option *ngFor="let item of filteredCategories | async" [value]="item">
          {{ item | chipListDescription: activeFilter}}
        </mat-option>
      </mat-autocomplete>
      <ng-content></ng-content>
    </mat-chip-list>
  </mat-form-field>
</form>
